import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function ResizeIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15 0H1C0.448 0 0 0.448 0 1V15C0 15.552 0.448 16 1 16H15C15.552 16 16 15.552 16 15V1C16 0.448 15.552 0 15 0ZM14 14H6V11C6 10.448 5.552 10 5 10H2V2H14V14Z" />
        <path d="M12 4H7L8.793 5.793L6.293 8.293L7.707 9.707L10.207 7.207L12 9V4Z" />
      </svg>
    </Icon>
  );
}
